/* eslint-disable camelcase */
import React, { useState } from 'react';
import Table from 'components/common/Table';
import PauseButton from 'components/common/Svg/Pause';
import Checkmark from 'components/common/Svg/Checkmark';
import { MenuItem, Menu } from "@material-ui/core";
import moment from 'moment';
import { getNextTimeFromCron } from '../utils/recurringOptions';

const guessedTz = moment.tz.guess();
const computeColumns = ({
  setAnchorEl,
  setCampaign,
}) => {
  return [
    {
      Header: "Batch Name",
      accessor: "batch_name",
    },
    {
      Header: "Scheduled by",
      accessor: "scheduled_by",
    },
    {
      Header: "Status",
      accessor: (data) => data.status,
    },
    {
      Header: "Next Scheduled Run",
      accessor: (data) => {
        const { scheduled_time } = data;
        const scheduledTime = moment.tz(scheduled_time, "UTC");
        let nextRun = 'None';
        if (data.cron_schedule && data.status !== 'CANCELLED') {
          nextRun = getNextTimeFromCron(data.cron_schedule); // moment objected returnd.
        } else if (!['CANCELLED', 'COMPLETED'].includes(data.status)) {
          nextRun = scheduledTime;
        }
        return (
          <div>{ nextRun === 'None' ? 'None' : nextRun.tz(guessedTz).format("MM-DD-YYYY hh:mm:ss zz") }</div>
        );
      },
    },
    {
      Header: "Created At",
      accessor: (data) => {
        const { created_at } = data;
        return (
          <div>{moment.tz(created_at, "UTC").tz(guessedTz).format("MM-DD-YYYY hh:mm:ss zz")}</div>
        );
      },
    },
    {
      Header: "Pause/Cancel",
      accessor: (data) => {
        const onclick = (event) => {
          setAnchorEl(event.currentTarget);
          setCampaign(data);
        };

        return (
          <div>
            { ['COMPLETED', 'CANCELLED'].includes(data.status) ? (
              <Checkmark
                height={30}
                width={30}
                color="#26E3BA"
                onClick={onclick}
              />
            ) : (
              <PauseButton
                height={30}
                width={30}
                color="#26E3BA"
                onClick={onclick}
              />
            )}
          </div>
        );
      },
    },
  ];
};

export default ({
  campaigns,
  handleModifyState,
}) => {
  const [anchorElement, setAnchorEl] = useState(null);
  const [campaign, setCampaign] = useState(null);

  const handleOnClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Table
        data={campaigns}
        id="Market Campaigns"
        columns={computeColumns({ setAnchorEl, setCampaign })}
      />
      <Menu
        id="pause-menu"
        anchorEl={anchorElement}
        keepMounted
        open={Boolean(anchorElement)}
        onClose={handleOnClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        getContentAnchorEl={null}
      >
        {
          campaign?.cron_schedule &&  campaign?.status === 'PAUSED' && (
            <MenuItem onClick={() => {
              handleModifyState(campaign, 'SCHEDULED');
            }}>
              <small>RESUME</small>
            </MenuItem>
          )
        }
        {
          campaign?.cron_schedule && campaign?.status !== 'CANCELLED' && (
            <MenuItem onClick={() => {
              handleModifyState(campaign, 'PAUSED');
            }}>
              <small>PAUSE</small>
            </MenuItem>
          )}
        { campaign?.status !== 'CANCELLED' &&
            (
              <MenuItem onClick={() => {
                handleModifyState(campaign, 'CANCELLED');
              }}>
                <small>CANCEL</small>
              </MenuItem>
            )}
      </Menu>
    </div>
  );
};